import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        position: "relative",
        alignItems: "center",
        overflow: "hidden",
        height: "100%",
        width: "100%"
    },
    backgroundImage: {
        position: "absolute",
        height: "100%",
        width: "100%",
        opacity: 0.5,
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    image: {
        height: "100%",
        width: "100%"
    }
});

export default stylesheet;
